export default "__VITE_ASSET__sPE0ppKW__"